import React from 'react'
import PropTypes from 'prop-types'
import { STATUS } from '../status'

// Outline face matching the Figma SVGs (stroke 1.5, like BellOnIcon).
// Circle + eyes are shared across statuses; only the mouth changes.
const CIRCLE = 'M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 '
  + '17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 '
  + '13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 '
  + '19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 '
  + '3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 '
  + '3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z'

const EYES = 'M9.75 9.75C9.75 10.164 9.582 10.5 9.375 10.5C9.168 10.5 9 10.164 9 9.75C9 9.336 '
  + '9.168 9 9.375 9C9.582 9 9.75 9.336 9.75 9.75ZM9.375 9.75H9.383V9.765H9.375V9.75ZM15 9.75C15 '
  + '10.164 14.832 10.5 14.625 10.5C14.418 10.5 14.25 10.164 14.25 9.75C14.25 9.336 14.418 9 '
  + '14.625 9C14.832 9 15 9.336 15 9.75ZM14.625 9.75H14.633V9.765H14.625V9.75Z'

const MOUTH = {
  smile: 'M15.182 15.182C14.7641 15.5999 14.2681 15.9313 13.7221 16.1575C13.1761 16.3836 12.591 '
    + '16.5 12 16.5C11.409 16.5 10.8239 16.3836 10.2779 16.1575C9.73194 15.9313 9.23586 15.5999 8.818 15.182',
  meh: 'M8.818 15.75H15.182',
  frown: 'M15.182 16.318C14.3429 15.4767 13.2042 15.0027 12.016 15C11.4222 14.9971 10.8338 '
    + '15.1121 10.2849 15.3384C9.7359 15.5646 9.2373 15.8976 8.818 16.318'
}

const VARIANT_BY_STATUS = {
  [STATUS.GREEN]: 'smile',
  [STATUS.ORANGE]: 'meh',
  [STATUS.RED]: 'frown',
  [STATUS.NEUTRAL]: 'meh'
}

const FaceIcon = ({ status }) => {
  const mouth = MOUTH[VARIANT_BY_STATUS[status]] || MOUTH.meh
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg">
      <path
        d={`${mouth} ${CIRCLE} ${EYES}`}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

FaceIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUS)).isRequired
}

export default FaceIcon
